import React, { FC } from 'react';
import BookingCoverme, { BookingCovermeProps } from './BookingCoverme';

const BookingCovermeAdmin: FC<Partial<BookingCovermeProps>> = (props) => {
  return <BookingCoverme {...(props as BookingCovermeProps)} forceMode="admin" />;
};

export default BookingCovermeAdmin;
